<mbs-modal [title]="'shared:modals.assignLicenseWithoutAgent.title' | i18next: { format: 'capitalize' }">
  <ng-container modal-body>
    <p class="mb-0">
      {{ 'shared:modals.assignLicenseWithoutAgent.startText' | i18next: { licenseType: licenseTypeName() } }}
      <span class="fw-semibold">{{ computerName() }}</span>
      {{ 'shared:modals.assignLicenseWithoutAgent.endText' | i18next: { agent: agentName() } }}
    </p>
  </ng-container>

  <ng-container modalFooter>
    <mbs-button
      [type]="'primary'"
      (click)="handleProceed()">
      {{ 'shared:buttons.proceed' | i18next: { format: 'capitalize' } }}
    </mbs-button>

    <mbs-button (click)="handleCancel()">
      {{ 'shared:buttons.cancel' | i18next: { format: 'capitalize' } }}
    </mbs-button>
  </ng-container>
</mbs-modal>
